module.exports = __webpack_public_path__ + "img/about-outline.f6ff70ca.svg";